import { useLastPathSegment } from 'shared/hooks'

export const usePathSegment = <T extends string>() => {
  return useLastPathSegment() as T
}
